import HowToResults from './HowToResults'

export default HowToResults
